module.exports = __webpack_public_path__ + "img/interior.db1c8987.png";